import React, { Component } from "react";
import Routes from "./Route.js";
import { Auth } from "aws-amplify";
import store from "./store/index";
import {updateTimeSettings} from "./actions/index";
import { updateTimeSettingsOneByOne, updateCommissionSetting, updateBackStakeSetting, updateLayStakeSetting } from "./actions/index";
import { updateFilteredCountryList } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import {update_Is_Exact_Time_One_By_One} from "./actions/index";
import {updateT0Settings} from "./actions/index";
import {update_Steamer_Drifter_Settings} from "./actions/index";
import {updateLocalTimeOffSetToGmt} from "./actions/index";
import {updateLocalTimeZone} from "./actions/index";
import {updateLatestOddsSettings} from "./actions/index";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';


class App extends Component {

  constructor(props) {
  super(props);

  this.state = {
    isAuthenticated: false,
    isAuthenticating: true,
    userName:""
  };

}

// async initializeUserInfo(){
// try {
// const info = await Auth.currentUserInfo()
// console.log('Returned info:: ', info)
// this.setState({
//   userInfo:info.attributes.email
// })
// }catch (e) {
// console.log("Error");
// //alert(e.message);
// }
// }

//convertMinutesToLocalTimeZone = num =>
// { 
//  let sign = "+";
//  if(num < 0) sign = "-"
//  num = Math.abs(num);
//  const hours = Math.floor(num / 60);  
//  const minutes = num % 60;
//  return  "GMT" + sign + (hours < 10  ? "0" + hours : hours)  + ":" + (minutes < 10  ? "0" + minutes : minutes) ;         
//}

async componentDidMount() {
  try {
    await Auth.currentSession();

    const user =  await Auth.currentAuthenticatedUser();
    const userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
    if(userGroups === undefined || !userGroups.includes("greyhound-price-monitor")) {
        throw new Error("You don't have access to this application. Please contact site administrator.");
    }
    

    try {
    this.userHasAuthenticated(true);
    const info = await Auth.currentUserInfo()
    //console.log('Returned info:: ', info)

    //const offset = new Date().getTimezoneOffset() * -1;
    //const timezone = this.convertMinutesToLocalTimeZone(offset);
    //console.log("timezone offset: " + offset + ", timezone: " + timezone);
    //store.dispatch(updateLocalTimeOffSetToGmt(offset));
    //store.dispatch(updateLocalTimeZone(timezone));

    

    let payload={}
    payload.id = "t1"
    payload.value = info.attributes["custom:gh:t1"]
    store.dispatch(updateTimeSettingsOneByOne(payload))

    payload.id = "t2"
    payload.value = info.attributes["custom:gh:t2"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t3"
    payload.value = info.attributes["custom:gh:t3"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t4"
    payload.value = info.attributes["custom:gh:t4"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t5"
    payload.value = info.attributes["custom:gh:t5"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t6"
    payload.value = info.attributes["custom:gh:t6"]
    store.dispatch( updateTimeSettingsOneByOne(payload))

    payload.id = "t0"
  payload.value = info.attributes["custom:gh:t0"].split("|")[0]
  store.dispatch(updateTimeSettingsOneByOne(payload))

  payload.id = "commision"
  payload.value = info.attributes["custom:gh:t0"].split("|")[1]
  store.dispatch(updateCommissionSetting(payload))

  payload.id = "backStake"
  payload.value = info.attributes["custom:gh:t0"].split("|")[2]
  store.dispatch(updateBackStakeSetting(payload))

  payload.id = "layStake"
  payload.value = info.attributes["custom:gh:t0"].split("|")[3]
  store.dispatch(updateLayStakeSetting(payload))


  payload.id = "diff"
  payload.value = info.attributes["custom:gh:t0"].split("|")[0]
  store.dispatch( updateT0Settings(payload))

    payload.id = "t1"
    payload.value = info.attributes["custom:gh:exact_t1"]
    store.dispatch(updateExactTimeSettingsOneByOne(payload))

    payload.id = "t2"
    payload.value = info.attributes["custom:gh:exact_t2"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t3"
    payload.value = info.attributes["custom:gh:exact_t3"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t4"
    payload.value = info.attributes["custom:gh:exact_t4"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t5"
    payload.value = info.attributes["custom:gh:exact_t5"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    payload.id = "t6"
    payload.value = info.attributes["custom:gh:exact_t6"]
    store.dispatch( updateExactTimeSettingsOneByOne(payload))

    const tValue = info.attributes["custom:gh:t0_type"]
    

    payload.id = "t0"
    payload.value = tValue.split("|")[0]
    store.dispatch(updateExactTimeSettingsOneByOne(payload))

    payload.id = "t1"
    payload.value = tValue.split("|")[1]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t2"
    payload.value = tValue.split("|")[2]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t3"
    payload.value = tValue.split("|")[3]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))

    payload.id = "t4"
    payload.value = tValue.split("|")[4]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t5"
    payload.value = tValue.split("|")[5]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    payload.id = "t6"
    payload.value = tValue.split("|")[6]
    store.dispatch( update_Is_Exact_Time_One_By_One(payload))
    
    payload.id = "option"
    payload.value = tValue.split("|")[0]
    store.dispatch( updateT0Settings(payload))

    
    //Steamer Drifter Settings
    const steamerDrifter = info.attributes["custom:gh:t1_type"]
    payload.id = "STEAMER_MIN_PRICE"
    payload.value = steamerDrifter.split("|")[0]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "STEAMER_MAX_PRICE"
    payload.value = steamerDrifter.split("|")[1]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MIN_PRICE"
    payload.value = steamerDrifter.split("|")[2]
    store.dispatch( update_Steamer_Drifter_Settings(payload))
    payload.id = "DRIFTER_MAX_PRICE"
    payload.value = steamerDrifter.split("|")[3]
    store.dispatch( update_Steamer_Drifter_Settings(payload))


    const volumeCountry = info.attributes["custom:gh:t2_type"]
    payload.id = "MIN_VOLUME"
    payload.value = volumeCountry.split("|")[0]
    store.dispatch( update_Steamer_Drifter_Settings(payload))

    let filteredCountryList = volumeCountry.split("|")[1]
    var Arr = filteredCountryList.split(',');
    store.dispatch(updateFilteredCountryList(Arr))
    //console.log('  ', filteredCountryList)

    // load latestOddsSettings
    payload.id = "tickUntilActualStart"
    payload.value = volumeCountry.split("|")[2]
    store.dispatch(updateLatestOddsSettings(payload))

    payload.id = "noOfSeconds"
    payload.value = volumeCountry.split("|")[3]
    store.dispatch(updateLatestOddsSettings(payload))


    //store.dispatch(updateTimeSettings(timesettings))
    }catch (e) {
    console.log("Error");
    //alert(e.message);
    }

  }
  catch(e) {
    console.log(e)
    if (e !== 'Invalid username or password.') {
      // alert(e);
    }
  }

  this.setState({ isAuthenticating: false });
}

userHasAuthenticated = (authenticated,user) => {
  this.setState({ isAuthenticated: authenticated, userName: user });
}

  render() {


    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      userName: this.state.userName
    };
    return (
      !this.state.isAuthenticating &&
      <div className="App container">
      <NotificationContainer/>  
      <Routes childProps={childProps}/>
      </div>
    );
  }
}

export default App;
